import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";

@Injectable({
  providedIn: 'root'
})
export class AccountService extends BaseRestService {

  public accounts = {};

  public selectedAccount: any;

  readonly ACCOUNT_URL: string = environment.apiUri + '/account';
  readonly REVALUATION_ENDPOINT: string = this.ACCOUNT_URL + '/revaluation';
  readonly SAVING_ACCOUNT_URL: string = environment.savingUri + '/saving-agreements/customers/accounts';

  getList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.ACCOUNT_URL, options);
  }

  getAccountListByCustomerId(customerId: string, pageParams?: any, query?: string): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.SAVING_ACCOUNT_URL + `/${customerId}` + `?` + query, options);
  }

  getById(id): Observable<any> {
    return this.httpClient.get(this.ACCOUNT_URL + '/' + id, { headers: this.headers });
  }

  getByAccountNumber(accountNumber): Observable<any> {
    const options = {
      headers: this.headers
    }
    return this.httpClient.get(this.ACCOUNT_URL + '/account-number?accountNumber=' + accountNumber, options);
  }

  getByCustomerId(id): Observable<any> {
    return this.httpClient.get(this.ACCOUNT_URL + '/customer/' + id, { headers: this.headers });
  }

  getDocumentNumber(): Observable<any> {
    return this.httpClient.get(this.REVALUATION_ENDPOINT + "/document-number", { headers: this.headers });
  }

  create(account): Observable<any> {
    return this.httpClient.post(this.ACCOUNT_URL, JSON.stringify(account),
      { headers: this.headers });
  }

  update(id: string, data): Observable<any> {
    return this.httpClient.put(this.ACCOUNT_URL + "/" + id, JSON.stringify(data),
      { headers: this.headers });
  }

  closeAccount(id): Observable<any> {
    return this.httpClient.put(this.ACCOUNT_URL + '/close/' + id,
      { headers: this.headers });
  }

  reopen(data): Observable<any> {
    return this.httpClient.put(this.ACCOUNT_URL + "/reopen", JSON.stringify(data),
      { headers: this.headers });
  }

  reopenById(id): Observable<any> {
    return this.httpClient.put(this.ACCOUNT_URL + "/reopen/" + id,
      { headers: this.headers });
  }

  revaluate(id: string, data): Observable<any> {
    return this.httpClient.post(this.REVALUATION_ENDPOINT + "/revaluate", JSON.stringify(data),
      { headers: this.headers });
  }

  import(formData): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Content-Type", " multipart/form-data");
    return this.httpClient.post(this.ACCOUNT_URL + "/import", formData,
        { headers: headers, 
          responseType: 'arraybuffer', 
          observe: 'response' 
        });
  }

  exportExcel(pageParams): Observable<any> {
    return this.httpClient.get(`${this.ACCOUNT_URL}/export`,
        {
            headers: this.headers,
            params: this.removeEmptyPropertyFromObject(pageParams),
            responseType: 'arraybuffer'
        });
  }

}
